import React from "react"

export const Filter = ({ setFilters, filters }) => {
  return (
    <div>
      {" "}
      <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 p-4 bg-gray rounded-xl shadow-inner animate-in slide-in-from-top duration-300'>
        <div className='flex flex-col'>
          <label className='text-sm font-medium text-gray-700 mb-2'>
            Coverage
          </label>
          <select
            className='w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition'
            onChange={(e) =>
              setFilters({ ...filters, coverage: e.target.value })
            }
            value={filters.coverage}
          >
            <option value=''>All Coverages</option>
            <option value='true'>National</option>
            <option value='false'>Selected Areas</option>
          </select>
        </div>

        <div className='flex flex-col'>
          <label className='text-sm font-medium text-gray-700 mb-2'>
            Beneficiary Type
          </label>
          <select
            className='w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition'
            onChange={(e) =>
              setFilters({ ...filters, beneficiary: e.target.value })
            }
            value={filters.beneficiary}
          >
            <option value=''>All Types</option>
            <option value='false'>Individual</option>
            <option value='true'>Household</option>
          </select>
        </div>

        <div className='flex flex-col'>
          <label className='text-sm font-medium text-gray-700 mb-2'>
            Status
          </label>
          <select
            className='w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition'
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
            value={filters.status}
          >
            <option value=''>All Status</option>
            <option value='pending'>Pending</option>
            <option value='completed'>Completed</option>
            <option value='ongoing'>Ongoing</option>
          </select>
        </div>
      </div>
    </div>
  )
}
